export default __webpack_public_path__ + "static/media/run-success.8d9c16b1.svg";